var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, Suspense } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import './index.scss';
import { VIEW_RENDER_CREATE, VIEW_RENDER_LIST, VIEW_RENDER_EDIT } from '../../utils/Constant';
import { mediaData } from '../../store/widget/reducer';
import { publisherData } from '../../store/publisher/reducer';
import { getPublishersByCurrentUser } from '../../utils/CommonUtil';
import * as Constant from "../../utils/Constant";
var Loading = function () { return React.createElement("div", null, "Loading..."); };
var LazyNoteListWrapper = React.lazy(function () { return import('./components/noteListWrapper'); });
var NoteListWrapper = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyNoteListWrapper, __assign({}, props)));
};
var LazyNoteAdd = React.lazy(function () { return import('./components/noteAdd'); });
var NoteAdd = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyNoteAdd, __assign({}, props)));
};
var NoteDetailsPage = function (props) {
    var t = useTranslation().t;
    var history = useHistory();
    var mediaData = props.mediaData, publisherData = props.publisherData, match = props.match;
    var _a = useState(VIEW_RENDER_LIST), viewRender = _a[0], setViewRender = _a[1];
    var _b = useState(), publishers = _b[0], setPublishers = _b[1];
    var _c = useState(), medias = _c[0], setMedias = _c[1];
    var _d = useState(), param = _d[0], setParam = _d[1];
    useEffect(function () {
        getPublisher();
        document.title = t("page.note_details") + Constant.APP_NAME;
    }, []);
    useEffect(function () {
        var view = VIEW_RENDER_LIST;
        if (match && match.url.indexOf('create') !== -1) {
            view = VIEW_RENDER_CREATE;
        }
        if (match && match.url.indexOf('edit') !== -1) {
            var params = __assign({}, props.match.params);
            view = VIEW_RENDER_EDIT;
            setParam(params);
        }
        setViewRender(view);
    }, [match]);
    var getPublisher = function () {
        var publisherList = getPublishersByCurrentUser();
        setPublishers(publisherList);
    };
    return (React.createElement(MainLayout, null,
        viewRender == VIEW_RENDER_LIST ?
            React.createElement(NoteListWrapper, { mediaList: mediaData, publisherData: publisherData, dispatch: props.dispatch }) : null,
        viewRender == VIEW_RENDER_CREATE ?
            React.createElement(NoteAdd, { viewRender: viewRender, publisherList: publishers, mediaList: mediaData, dispatch: props.dispatch }) : null,
        viewRender == VIEW_RENDER_EDIT ?
            React.createElement(NoteAdd, { param: param, viewRender: viewRender, publisherList: publishers, mediaList: mediaData, dispatch: props.dispatch }) : null));
};
function mapStateToProps(state) {
    return {
        mediaData: mediaData(state),
        publisherData: publisherData(state)
    };
}
export default connect(mapStateToProps)(NoteDetailsPage);
